import styled from 'styled-components';
import Button from '@material-ui/core/Button';

// CONSTANTS
import { DANDELION, EARLY_DAWN } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const ButtonStyled = styled(Button)`
  transition: color 0.25s ease;

  .add-remove-btn {
    &__icon {
      display: block;
      font-size: 1.9rem;
      margin-bottom: 6px;
    }
  }

  &.add-remove-btn {
    &--with-status {
      padding: 13px !important;

      &.MuiButton-containedPrimary {
        background-color: ${EARLY_DAWN};
        color: inherit;

        .add-remove-btn__icon {
          color: ${DANDELION};
        }
      }

      .MuiButton-label {
        font-size: 1.4rem;
        flex-direction: column;

        ${breakpoints.down('xs')} {
          font-size: 1.2rem;
          font-weight: 400;
        }
      }
    }
  }

  &.loading {
    cursor: default;
    pointer-events: none;
  }

  ${breakpoints.down('xs')} {
    min-width: 0;
  }
`;

export default ButtonStyled;
